import { render, staticRenderFns } from "./ImportInventory.vue?vue&type=template&id=5c9046b6"
import script from "./ImportInventory.vue?vue&type=script&lang=js"
export * from "./ImportInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports